import { facetTypes, valueKey, facetCounts } from './constants';
import { convertConfigFacetsToMap } from './searchHelper';

const assignNewValues = (cachedState, newValues) => {
  const cachedValuesToRetain = cachedState.filter((value) => (
    newValues.filter((responseValue) => (
      value.value === responseValue.value
    )).length === 0
  )).map((value) => ({
    ...value,
    count: 0,
  }));
  return newValues.concat(cachedValuesToRetain);
};

const assignSelectedValues = (newValues, selectedValues) => {
  const selectedValuesNotInResponse = selectedValues.filter((selected) => (
    newValues.every((responseValue) => (responseValue.value !== selected))
  )).map((selectedValue) => ({
    value: selectedValue,
    count: 0,
  }));
  return newValues.concat(selectedValuesNotInResponse);
};

const sortValues = (newValues) => (
  newValues.sort((a, b) => {
    const compareNum = b.count - a.count;
    return compareNum !== 0 ? compareNum : String(a.value).localeCompare(b.value);
  })
);

const trimValues = (newValues, facetConfig) => {
  const targetLength = facetConfig.config && facetConfig.config.count ? facetConfig.config.count : facetCounts;
  return newValues.slice(0, targetLength);
};

const assignFacetValues = (cachedState, newValues, selectedValues, facetConfig) => {
  let newState = assignNewValues(cachedState, newValues);
  newState = sortValues(newState);
  newState = trimValues(newState, facetConfig);
  return assignSelectedValues(newState, selectedValues);
};

const isAValue = (value) => (!(value === null || value === undefined));

const findRangeInList = (values, value) => values.find((responseValue) => (
  (isAValue(value.to) && value.to === responseValue.to)
  || (isAValue(value.from) && value.from === responseValue.from)
));

const assignRangeValues = (cachedState, newValues) => {
  let draftValues = [...newValues];
  const cachedValuesToRetain = cachedState.map((value) => {
    const match = findRangeInList(draftValues, value);
    if (match) {
      draftValues = draftValues.filter((nextValue) => (nextValue !== match));
      return {
        ...value,
        count: match.count,
      };
    }
    return {
      ...value,
      count: 0,
    };
  });
  return draftValues.concat(cachedValuesToRetain);
};

const assignOtherValues = (filterValues) => filterValues.map((value) => (
  typeof value === 'object' ? {
    ...value,
    count: 0,
  }
    : {
      value,
      count: 0,
    }
));

const buildListFacetValues = (filterKey, filterValues, newFacets, oldFacets, facetConfig) => {
  if ((newFacets && filterKey in newFacets) || (oldFacets && filterKey in oldFacets)) {
    if ((newFacets[filterKey][0] && valueKey in newFacets[filterKey][0])
        || (oldFacets[filterKey][0] && valueKey in oldFacets[filterKey][0])) {
      return assignFacetValues(oldFacets[filterKey], newFacets[filterKey], filterValues, facetConfig);
    }
    return assignRangeValues(oldFacets[filterKey], newFacets[filterKey]);
  }
  // Should only be called if both our state and our response doesn't contain the key thats in our filters
  return assignOtherValues(filterValues);
};

const filterBlankFacetValues = (inputFacets, facetConfigMap) => (
  Object.entries(inputFacets).reduce((currentFacets, entry) => {
    const newFacets = { ...currentFacets };
    const [facetKey, facetProperties] = entry;
    const facetConfig = facetConfigMap[facetKey];
    if (facetConfig && facetConfig.type !== facetTypes.BOOLEAN) {
      newFacets[facetKey] = facetProperties.filter((facetValue) => facetValue.value !== '');
    }
    return newFacets;
  }, { ...inputFacets })
);

const applyFilterStateToResponse = (draftFacets, newFacets, draftFilter, facetConfigMap) => {
  const mergedFacets = { ...draftFacets };
  Object.keys(newFacets).forEach((filterKey) => {
    const filterValues = (draftFilter && draftFilter[filterKey]) || [];
    const facetConfig = facetConfigMap[filterKey];
    if (facetConfig) {
      mergedFacets[filterKey] = buildListFacetValues(filterKey, filterValues, newFacets, draftFacets, facetConfig);
    }
  }, draftFilter);
  return filterBlankFacetValues(mergedFacets, facetConfigMap);
};

const updateFacets = (draftFacets, newFacets, draftFilter, facetConfigs) => {
  const facetConfigMap = convertConfigFacetsToMap(facetConfigs);
  if (draftFacets && Object.entries(draftFacets).length > 0) {
    return applyFilterStateToResponse(draftFacets, newFacets, draftFilter, facetConfigMap);
  }
  return filterBlankFacetValues(newFacets, facetConfigMap);
};

export default updateFacets;
